import { LinearProgressChart, LinearProgressListItem } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useDurationFormat } from '~/hooks/useDurationFormat/useDurationFormat';

import { toValueTriplet, TripletProps } from './MinMaxAverageListItem.util';

export const MinMaxAverageListItem = ({ metric, ...props }: { metric: string } & TripletProps) => {
  const { t } = useTranslation(I18nNamespace.base, { keyPrefix: 'NegotiationProcessWidget' });
  const format = useDurationFormat();
  const triplet = toValueTriplet(props);

  if (!triplet) {
    return <LinearProgressListItem primary={t(`label.${metric}`)} primaryRight="" secondary={t('label.noData')} />;
  }

  return (
    <LinearProgressListItem
      primary={t(`label.${metric}`)}
      primaryRight={format(triplet.avg)}
      secondary={format(triplet.min)}
      secondaryRight={format(triplet.max)}
    >
      <LinearProgressChart value={triplet.avg} min={triplet.min} max={triplet.max} tooltipFormatter={format} />
    </LinearProgressListItem>
  );
};
